<template>
  <div class="mt-10 max-w-xl mx-auto">
    <div>
      <form id="contact-form" class="grid grid-cols-1 row-gap-6 sm:grid-cols-2 sm:col-gap-8">
        <contact-form-errors :errors="errors" :is-dark="false"/>
        <contact-form-first-name
            :is-active="activeInput"
            :value="params.name"
            @input="params.name = $event"
            @active="activeInput = $event"/>
        <contact-form-email
            :is-active="activeInput"
            :value="params.email"
            @input="params.email = $event"
            @active="activeInput = $event"
        />
        <contact-form-phone
            :is-active="activeInput"
            :value="params.phone"
            @input="params.phone = $event"
            @active="activeInput = $event"
        />
        <contact-form-message
            :is-active="activeInput"
            :value="params.message"
            @input="params.message = $event"
            @active="activeInput = $event"/>
        <contact-form-submit @onContactSubmit="onContactSubmit" :loading="loading"/>
      </form>
    </div>
  </div>
</template>

<script>
import {gsap} from "gsap";
import ContactFormErrors from "@/components/utils/contact-form/ContactFormErrors";
import ContactFormFirstName from "@/components/utils/contact-form/ContactFormFirstName";
import ContactFormEmail from "@/components/utils/contact-form/ContactFormEmail";
import ContactFormPhone from "@/components/utils/contact-form/ContactFormPhone";
import ContactFormMessage from "@/components/utils/contact-form/ContactFormMessage";
import ContactFormSubmit from "@/components/utils/contact-form/ContactFormSubmit";
import db from '@/firebaseConfig'
import contactForm from "@/mixins/contactForm";

export default {
  name: "ContactForm",
  mixins: [contactForm],
  components: {
    ContactFormErrors,
    ContactFormFirstName,
    ContactFormEmail,
    ContactFormPhone,
    ContactFormMessage,
    ContactFormSubmit
  },
  computed: {
    elements: function () {
      return gsap.utils.toArray("#contact-form > div");
    },
  },
  methods: {
    insertMessage() {
      this.loading = true
      db.collection("messages")
          .add({...this.params, time: new Date()})
          .then(() => {
            this.loading = false
            this.$emit('messageSent')
            this.resetComponentState()
          })
          .catch((error) => {
            // TODO: ney :(
            this.loading = false
            console.error("Error writing document: ", error);
          });
    },
    animationsInit() {
      const scroller = this.$parent.$parent.$refs["scrollSections"];
      this.elements.forEach((element) => {
        gsap.to(element, {
          scrollTrigger: {
            trigger: element,
            scroller: scroller,
            start: "top 95%",
            end: "bottom 25%",
          },
          ease: "slow",
          y: 0,
          opacity: 1,
          autoAlpha: 1,
          duration: 1,
        });
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.elements.forEach((element) => {
        gsap.set(element, {
          y: 100,
          opacity: 0,
          autoAlpha: 0,
        });
      });
      this.animationsInit();
    });
  },
};
</script>

<style scoped>
</style>
